/**
 *
 * Asynchronously loads the component for Career Advice
 *
 */

import loadable from '@loadable/component';

export default loadable(() => import('./index'));
